// extracted by mini-css-extract-plugin
module.exports = {"authContainer":"AuthScreen_authContainer__1POJ8","logoContainer":"AuthScreen_logoContainer__czc0n","googleSSO":"AuthScreen_googleSSO__jaXdq"};